// extractApiErrors.ts

export const extractApiErrors = (error: unknown): string[] => {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return [];
  }

  const response = error.response;

  if (
    !response ||
    typeof response !== 'object' ||
    !('data' in response) ||
    !response.data ||
    typeof response.data !== 'object'
  ) {
    return [];
  }

  return Object.values(response.data)
    .flatMap(value => (Array.isArray(value) ? value : []))
    .filter((message): message is string => typeof message === 'string');
};
